import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import {
    Dialog,
    MemberName,
    Select,
    Tooltip,
} from 'react-wot-bootstrap'

import * as dialogActions from 'state/actions/CMT/Dialog'
import * as membersOperationActions from 'state/actions/CMT/MembersOperation'

import {
    getAssignableRole,
    getAssignableRoles,
    getLocalizedName,
} from 'utils/clan_management/roles'

import { DIALOG_BUTTON_CANCEL_CAPTION } from '../translations'

import {
    DIALOG_CHANGE_ROLE_TITLE,
    DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION,
    DIALOG_CHANGE_ROLE_MEMBER_TITLE,
    DIALOG_CHANGE_ROLE_MEMBERS_TITLE,
    DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE,
    USER_ROLES_DESCRIPTIONS,
} from './translations'

import {
    DialogChangeRolePlayersTooltip,
    DialogChangeRoleSelectTooltip,
} from './tooltips'

import styles from '../Dialogs.scss'

const propTypes = {
    currentMemberRole: PropTypes.string.isRequired,
    selectedMembers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,

    selectedRole: PropTypes.string,
    isOpened: PropTypes.bool,

    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onRoleChange: PropTypes.func.isRequired,
}

export class ChangeRoleDialog extends React.Component {
    state = {
        isSelectActive: false,
    }

    onSelectToggled = (isSelectActive) => {
        this.setState({ isSelectActive })
    }

    render() {
        const selectedRole = getAssignableRole(this.props.currentMemberRole, this.props.selectedRole)
        const suitableRoleNames = getAssignableRoles(this.props.currentMemberRole)

        const selectItems = suitableRoleNames.map(roleName => ({
            value: roleName,
            caption: getLocalizedName(roleName),
            tooltipId: `role-tooltip-${roleName}`,
        }))

        const rolesTooltips = suitableRoleNames.map(roleName => (
            <Tooltip id={`role-tooltip-${roleName}`} key={roleName}>
                <div className={styles.tooltipContent}>
                    <h3 className={styles.tooltipSubtitle}>
                        {getLocalizedName(roleName)}
                    </h3>
                    <p className={styles.tooltipMessage}>
                        {USER_ROLES_DESCRIPTIONS[roleName]}
                    </p>
                </div>
            </Tooltip>
        ))

        let members = null
        let tooltip = null
        const selectedMembersCount = this.props.selectedMembers.length
        const isNeedTooltip = selectedMembersCount > 10
        if (selectedMembersCount === 1) {
            members = (<MemberName name={this.props.selectedMembers[0].name} />)
        } else if (selectedMembersCount > 1) {
            members = this.props.selectedMembers.map((member) => (
                <MemberName key={member.id} name={member.name} />
            ))
            tooltip = isNeedTooltip ? (
                <DialogChangeRolePlayersTooltip>
                    {members}
                </DialogChangeRolePlayersTooltip>
            ) : null

            members = isNeedTooltip ? (
                <span className={styles.membersCount}>{selectedMembersCount}</span>
            ) : (
                <div className={styles.members}>{members}</div>
            )
        }

        const selectTooltip = this.state.isSelectActive ? null : (
            <DialogChangeRoleSelectTooltip />
        )

        return (
            <Dialog
                title={DIALOG_CHANGE_ROLE_TITLE}
                submitCaption={DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION}
                closeCaption={DIALOG_BUTTON_CANCEL_CAPTION}
                isOpened={this.props.isOpened}
                isFocusOnSubmitBtn
                onSubmit={this.props.onSubmit}
                onClose={this.props.onClose}
            >
                <div className={styles.base}>
                    <div
                        className={styles.header}
                        data-tip={isNeedTooltip}
                        data-for={isNeedTooltip ? DialogChangeRolePlayersTooltip.id : null}
                    >
                        {selectedMembersCount > 1 ? DIALOG_CHANGE_ROLE_MEMBERS_TITLE : DIALOG_CHANGE_ROLE_MEMBER_TITLE}
                        &ensp;
                        {members}
                        {tooltip}
                    </div>
                    <div className={styles.divider} />
                    <div className={styles.body}>
                        <div className={styles.row}>
                            <div className={classNames(styles.caption, styles['caption__changeRole'])}>
                                {DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE}
                            </div>
                            <Select
                                width={190}
                                items={selectItems}
                                selectedItem={selectedRole}
                                tooltipId={this.state.isSelectActive ? null : DialogChangeRoleSelectTooltip.id}
                                onItemChange={this.props.onRoleChange}
                                onToggled={this.onSelectToggled}
                            />
                            {selectTooltip}
                            {rolesTooltips}
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}

ChangeRoleDialog.propTypes = propTypes

const mapStateToProps = (state, ownProps) => {
    const members = state.members.members
    const currentMember = members.find((member) => member.id === state.account.id)
    const selectedMembers =
        ownProps.selectedMembers ||
        members.filter((member) => state.membersOperation.selectedIds.includes(member.id))
    return {
        currentMemberRole: currentMember.role,
        selectedMembers,
        selectedRole: state.membersOperation.selectedRole,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSubmit: ownProps.onSubmit,
        onClose: () => dispatch(dialogActions.hideDialog()),
        onRoleChange: (roleName) => dispatch(membersOperationActions.selectRoleMembersOperation(roleName)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRoleDialog)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/ChangeRole/ChangeRole.js